import React from 'react';
import { Empty, Button, Space } from 'antd';
import { ReloadOutlined, ClearOutlined } from '@ant-design/icons';
import { spacing } from './tokens';

interface EmptyStateProps {
  description?: string;
  image?: React.ReactNode;
  action?: React.ReactNode;
  onRefresh?: () => void;
  onClearFilters?: () => void;
  showActions?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  description = 'Không có dữ liệu',
  image,
  action,
  onRefresh,
  onClearFilters,
  showActions = true,
}) => {
  const defaultActions = showActions && (onRefresh || onClearFilters) && (
    <Space>
      {onRefresh && (
        <Button
          type="primary"
          icon={<ReloadOutlined />}
          onClick={onRefresh}
          aria-label="Làm mới dữ liệu"
        >
          Làm mới
        </Button>
      )}
      {onClearFilters && (
        <Button
          icon={<ClearOutlined />}
          onClick={onClearFilters}
          aria-label="Xóa bộ lọc"
        >
          Xóa bộ lọc
        </Button>
      )}
    </Space>
  );

  return (
    <div style={{ padding: spacing.xxl, textAlign: 'center' }}>
      <Empty
        description={description}
        image={image}
        imageStyle={{ height: 120 }}
      >
        {action || defaultActions}
      </Empty>
    </div>
  );
};
